import React from 'react';
import BankIcon from 'assets/images/bank-icon.png';
import BetIcon from 'assets/images/bet-icon.png';
import WinIcon from 'assets/images/win-icon.png';
import GameMenu from 'components/GameMenu';
import { formatMoney } from 'utils/numbers';
import 'assets/styles/app-header.scss';

const AppHeader = ({
    bank,
    gameId,
    bet,
    win,
    soundOn,
    toggleSound
}) => {
    return <div className="app-header">
        <div className="items">
            <div className="item">
                <div className="inputs">
                    <img className="icon" src={BankIcon} />
                    <div className="value-wrapper">
                        <span className="value">
                            {formatMoney(bank)}
                        </span>
                        <div className="label">BANK</div>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="inputs">
                    <img className="icon" src={BetIcon} />
                    <div className="value-wrapper">
                        <span className="value">
                            {formatMoney(bet)}
                        </span>
                        <div className="label">BET</div>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className="inputs">
                    <img className="icon" src={WinIcon} />
                    <div className="value-wrapper">
                        <span className="value">
                            {formatMoney(win)}
                        </span>
                        <div className="label">WIN</div>
                    </div>
                </div>
            </div>
            <div className="game-id">
                <p>GAME ID:</p>
                <p>{gameId}</p>
            </div>
        </div>
        <GameMenu soundOn={soundOn} toggleSound={toggleSound} gameId={gameId} />
    </div>;
};

AppHeader.defaultProps = {
    bank: '$0.00',
    win: 0,
};

export default AppHeader;